var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from "moment";
export var DownloadPageListMapper = function (data) {
    var reportList = __assign(__assign({}, data), { data: [] });
    if (data && data.data.length > 0) {
        data.data.map(function (reportRecord) {
            var reportDataEntityRecord = {
                fileId: reportRecord.id,
                fileName: reportRecord.file_name,
                statusId: reportRecord.status,
                statusValue: reportRecord._status,
                requestDateTime: moment(reportRecord.request_datetime).format("DD/MM/YYYY"),
                completeDateTime: reportRecord.completed_datetime,
            };
            reportList.data.push(reportDataEntityRecord);
        });
    }
    return reportList;
};
